export class LevelEditorDropPanel extends Phaser.Group {
  /**
   * constructor
   * @param {number} x
   * @param {number} y
   * @param {Object} lvlData
   */
  constructor(x, y, lvlData) {
    super(game);

    this.x = G.l(x);
    this.y = G.l(y);
    this._lvlData = lvlData;
    this._drops = this._lvlData.drops;

    this.signals = {
      onDropFieldModified: new Phaser.Signal(),
    };

    this.add(new G.Text(0, 0, '% DROPS:', 'editor', [0, 0.5], 400));
    this._initDropFields();
  }

  /**
   * init the drop files
   */
  _initDropFields() {
    // make board item fields
    this._makeDropField(0, 50, 'candy_chest', 'chest');
    this._makeDropField(0, 100, 'status_chain_2', 'chain');
    this._makeDropField(0, 150, 'candy_infection', 'infection');
    this._makeDropField(0, 200, 'candy_goalCandy', 'goalCandy');
    this._makeDropField(0, 250, 'candy_burntCandy', 'burntCandy');
    this._makeDropField(0, 300, 'gem_box_neutral', 'bx');

    this._makeDropField(200, 450, 'status_chain_1', 'W|1');
    this._makeDropField(200, 500, 'status_chain_2', 'W|2');
    this._makeDropField(200, 550, 'status_chain_3', 'W|3');

    this._makeDropField(200, 50, 'gem_box_1', 'bx|1');
    this._makeDropField(200, 100, 'gem_box_2', 'bx|2');
    this._makeDropField(200, 150, 'gem_box_3', 'bx|3');
    this._makeDropField(200, 200, 'gem_box_4', 'bx|4');
    this._makeDropField(200, 250, 'gem_box_5', 'bx|5');
    this._makeDropField(200, 300, 'gem_box_6', 'bx|6');
    this._makeDropField(200, 350, 'gem_box_r', 'bx|r');

    // make basic candy type fields
    G.Helpers.candyDataMgr.getTypesWithTag('regular').forEach((type, i) => {
      this._makeDropField(0, 400 + (i * 50), type.texture, type.editorSymbol);
    });
  }

  /**
   * make drop edit / display field
   * @param {number} x
   * @param {number*} y
   * @param {string} spriteName
   * @param {string} propName
   */
  _makeDropField(x, y, spriteName, propName) {
    // make drop field icon
    const ico = G.makeImage(x + 50, y, spriteName, [0, 0.5], this);
    ico.scale.setTo(0.6);
    // make drop field text
    const txt = new G.Text(x + 150, y - 30, this._drops[propName] || '0', 'editor-aquamarine');
    txt.inputEnabled = true;
    txt.input.useHandCursor = true;
    txt.events.onInputDown.add(() => {
      G.Utils.debugPrompt(`Enter % of getting ${propName}`).then(((answer) => {
        const parsedAnswer = parseFloat(answer);
        if (Number.isNaN(parsedAnswer)) return;
        if (parsedAnswer < 0 || parsedAnswer >= 100) return;
        this._lvlData.drops[propName] = parsedAnswer;
        txt.setText(parsedAnswer.toString());
        this.signals.onDropFieldModified.dispatch();
      }));
    });
    this.add(txt);
  }
}
